export enum UploadType {
  PARCEL = 'parcel',
  CAR = 'car'
}
